import { render, staticRenderFns } from "./alert-none-rateios.vue?vue&type=template&id=504217c6&scoped=true"
var script = {}
import style0 from "./alert-none-rateios.vue?vue&type=style&index=0&id=504217c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504217c6",
  null
  
)

export default component.exports